import type { ReportingNetworkConfig } from "@services/referenceData/reportingNetworkConfigService";

/** How a network is drawn: its label, icon and colour from the reporting reference data. */
export type NetworkLook = Pick<ReportingNetworkConfig, "label" | "icon" | "color">;

/** Keyed by the lower-case publisher network code the ad group and campaign rows carry. */
export type NetworkLooks = Record<string, NetworkLook>;

/** Publisher networks only -- direct delivery channels have no publisher_network (docs/channels.md). */
export function networkLooks(configs: ReportingNetworkConfig[]): NetworkLooks {
  const looks: NetworkLooks = {};
  for (const config of configs) {
    const network = config.publisher_network?.toLowerCase();
    if (network && !looks[network]) looks[network] = config;
  }
  return looks;
}

export default function NetworkTag({ network, looks }: { network: string; looks: NetworkLooks }) {
  const look = looks[network.toLowerCase()];
  return (
    <span className="adgroup-network">
      {look?.icon && <i className={`bi ${look.icon}`} style={{ color: look.color }} />}
      {look?.label ?? network}
    </span>
  );
}
